<template>
  <div class="main-div" style="height: 700px;width: 1200px">
    <xr-layout :layoutConfigure="layoutConfigure" >
      <template slot="west">
        <xr-table ref="xrTable" :configure="configure"></xr-table>
      </template>
      <template slot="center">
        <xr-data-table ref="xrDataTable" :configure="dataConfigure"></xr-data-table>
      </template>
    </xr-layout>
  </div>
</template>

<script>
  import XrDataTable from '../../../XrTable/dataTable'
  //人员多选
  export default {
    name: "pageSelectUser",
    data (){
      return {
        layoutConfigure:{
          westWidth:'600px'
        },
        configure: {
          url: '/web/service?method=tCoreUser_pageSelectList',
          listParam: {
            selectedIds: '-1',
            orgType: ''
          },
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          // tableHeight: '600px',
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'orgName',
              title: '所属部门',
              width: 150,
              condition: {
                searchType: 'input',
                searchName: 'orgNameSearch',
                value:''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
          ],
          toolbar: [
            {
              text: '添加',
              iconCls: 'wk wk-add',
              that: this,
              handler: function () {
                this.that.addSelectedUser();
              }
            }
          ]
        },
        dataConfigure: {
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          // tableHeight: '600px',
          columns: [
            {
              field: 'orgName',
              title: '所属部门',
              width: 150,
              condition: {
                searchType: 'input',
                searchName: 'orgNameSearch',
                value:''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },

          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ],
          tableData:[   //数据列表

          ]
        },
      }
    },
    components: {
      XrDataTable
    },
    methods: {
      init(ids,orgType, isOrgAuth) {
        this.configure.listParam['selectedIds'] = ids;
        this.configure.listParam['orgType'] = orgType;
        this.dataConfigure.tableData = [];
        this.$nextTick(()=>{
          this.$refs.xrTable.getData();
        })
      },
      //添加选中的用户
      addSelectedUser(){
        //1、获取以前选中的数据
        let selectedData = this.dataConfigure.tableData;
        let selectedStr = ',';
        if(selectedData != null && selectedData.length > 0){
          for (let i = 0; i < selectedData.length; i++) {
            selectedStr += selectedData[i].id + ',';
          }
        }

        //2、获取当前选中的，添加进右边的列表
        let list = this.$refs.xrTable.multipleSelectionItem
        if(list == null || list.length < 1){
          return false;
        }
        for (let i = 0; i < list.length; i++) {
          if(selectedStr.indexOf(',' + list[i].id + ',') == -1){
            selectedData.push(list[i]);
          }
        }

        //3、将组装后的tableData放回去
        this.dataConfigure.tableData = selectedData;
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let selectIds = '';
        let selectNames = '';
        let selectedData = this.dataConfigure.tableData;
        if(selectedData == null || selectedData.length < 1){
          alert('请选择！');
          return false;
        }
        for (let i = 0; i < selectedData.length; i++) {
          if(selectIds == ''){
            selectIds = selectedData[i].id;
            selectNames = selectedData[i].userName;
          }else{
            selectIds += ',' + selectedData[i].id;
            selectNames += ',' + selectedData[i].userName;
          }
        }
        this.$emit('confirmMethod',selectIds,selectNames);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/user/userMultiplePageSelect.vue